var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.5 14.58-1.495-1.39a5.294 5.294 0 1 0 1.182-1.183l1.472 1.446a3.277 3.277 0 1 1-1.16 1.128zm22.508.151L24.9 16.043l-3.782-4.84h2.117l2.773 3.53zm0 2.976-1.109-1.31-3.782 4.94h2.117l2.773-3.63zm1.21-1.31-1.109 1.31 2.772 3.63H31l-3.781-4.94zM26.11 14.73l1.108 1.312L31 11.202h-2.118l-2.773 3.53zm-8.522 3.178h1.664l-3.328-6.656-5.193 10.135h1.867l3.327-6.505 1.664 3.026zm.807 1.764.857 1.715h1.664l-.807-1.715h-1.715z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOax);
export default __webpack_public_path__ + "static/media/OAX.9562d103d72c80d6aae45c75e99a1cd4.svg";
export { ForwardRef as ReactComponent };